<template>
  <b-card class="bg-white rounded-xl">
    <AddNewsPopup :isOpen="isPopupOpen" @close="togglePopup" />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of News</h2>

        <small class="text-muted">Manage all your news here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          News</span
        >
      </base-button>
    </div>
    <NewsTable />
  </b-card>
</template>

<script>
import NewsTable from "./components/NewsTable.vue";
import AddNewsPopup from "./components/AddNewsPopup.vue";

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    NewsTable,
    AddNewsPopup,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addnewscontent" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
};
</script>
